import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import Tabs, { ReviewTabType } from './Tabs';
import NavTabBar, { TabItem } from 'components/base/Tabs';
import Header from 'components/common/Header';
import ScrollRestoreForSSR from 'components/common/ScrollRestoreForSsr';
import { useMount } from 'hooks';
import { WEB_MAX_WIDTH } from 'styles';

export const IS_SHOW_NEW_REVIEW_BADGE_KEY = 'IS_SHOW_NEW_REVIEW_BADGE';

const HOME_PATH = `/my-page/reviews?tab=`;

const tab_list: TabItem[] = [
  {
    id: ReviewTabType.REVIEWABLE,
    label: '작성 가능한 리뷰',
    href: `${HOME_PATH}${ReviewTabType.REVIEWABLE}`,
  },
  {
    id: ReviewTabType.COMPLETED,
    label: '작성한 리뷰',
    href: `${HOME_PATH}${ReviewTabType.COMPLETED}`,
  },
];

/**
 * 마이페이지 - 리뷰 리스트
 * @component
 */
const Review = () => {
  const { query } = useRouter();

  useMount(() => {
    const is_review_badge = localStorage.getItem(IS_SHOW_NEW_REVIEW_BADGE_KEY);
    if (is_review_badge) {
      localStorage.removeItem(IS_SHOW_NEW_REVIEW_BADGE_KEY);
    }
  });

  const selected_tab_id = getSelectedTabType(String(query.tab));
  const SelectedTab = Tabs[selected_tab_id];

  return (
    <>
      <SC.HeaderWrapper>
        <Header.Sub title='리뷰' />
        <NavTabBar tab_list={tab_list} selected_tab_id={selected_tab_id} />
      </SC.HeaderWrapper>
      <SelectedTab />
      <ScrollRestoreForSSR getSelectedTabType={getSelectedTabType} />
    </>
  );
};

export default Review;

function getSelectedTabType(tab?: string): ReviewTabType {
  if (!tab) {
    return ReviewTabType.REVIEWABLE;
  }

  const is_selected = Object.values(ReviewTabType).includes(tab as ReviewTabType);
  return is_selected ? (tab as ReviewTabType) : ReviewTabType.REVIEWABLE;
}

const SC = {
  HeaderWrapper: styled.div`
    position: fixed;
    max-width: ${WEB_MAX_WIDTH}px;
    width: 100%;
    z-index: 200;
  `,
  StyledNavTabBar: styled(NavTabBar)`
    position: fixed;
    max-width: ${WEB_MAX_WIDTH}px;
    z-index: 20;
  `,
};
